const Tags = [
  "All",
  "AI",
  "Testing",
  "Frontend",
  "Technology",
  "Business",
  "Design",
  "Java",
  "Entrepreneurship",
  "UI/UX",
];
export default Tags;
